// Libraries
import React, {createContext, useContext} from 'react';

type AppName = 'Admin' | 'Crew' | 'Customer' | 'Manager' | 'Sales';

// Simple context for passing presentation values for shared components
export interface PresentationContextType {
  appName?: AppName;
  isWidget: boolean;
}

const PresentationContext = createContext<PresentationContextType>({
  appName: undefined,
  isWidget: false,
});

interface PresentationContextProviderProps {
  appName?: AppName;
  children: React.ReactNode;
  isWidget?: boolean;
}

export const PresentationContextProvider = ({
  children,
  appName,
  isWidget = false,
}: PresentationContextProviderProps) => {
  return (
    <PresentationContext.Provider value={{appName, isWidget}}>
      {children}
    </PresentationContext.Provider>
  );
};

export const usePresentationContext = () => useContext(PresentationContext);

export default PresentationContext;
